import { TOKEN_COOKIE, OPTIMIZELY_USER_ID_COOKIE, OPTIMIZELY_USER_ID_COOKIE_MAX_AGE, COGNITO_KEY } from "../constants/keys.mjs";
import { getInfoLogger } from "./logger.mjs";
const base64ToString = (base64) => {
  return Buffer.from(base64, "base64").toString();
};
const getCognitoIdFromToken = (token) => {
  if (!token) {
    return void 0;
  }
  const actualToken = token.split(".")[1];
  const decoded = JSON.parse(actualToken ? base64ToString(actualToken) : "{}");
  return decoded[COGNITO_KEY] ?? void 0;
};
const getCognitoIdFromRequest = (req) => {
  const token = req.cookies[TOKEN_COOKIE];
  return getCognitoIdFromToken(token) ?? "";
};
const getExistingOptimizelyUserId = (req) => {
  const existingToken = req.cookies[TOKEN_COOKIE];
  let userId = "";
  const logger = getInfoLogger();
  if (existingToken) {
    logger(`optimizely existingToken ${TOKEN_COOKIE} found`);
    userId = getCognitoIdFromToken(existingToken);
  }
  if (!userId) {
    logger(
      `optimizely cognito id not found. checking ${OPTIMIZELY_USER_ID_COOKIE} cookie`
    );
    userId = req.cookies[OPTIMIZELY_USER_ID_COOKIE];
  }
  return userId;
};
const getOrSetOptimizelyUserId = (req, res) => {
  let id = getExistingOptimizelyUserId(req);
  const logger = getInfoLogger();
  if (!id) {
    id = crypto.randomUUID();
    logger("[optimizely] generating new user id");
    res.setHeader(
      "Set-Cookie",
      `${OPTIMIZELY_USER_ID_COOKIE}=${id}; Max-Age=${OPTIMIZELY_USER_ID_COOKIE_MAX_AGE}; Path=/`
    );
  }
  return id;
};
export {
  getCognitoIdFromRequest,
  getOrSetOptimizelyUserId
};
